import React, { FC } from "react";
import { EmblaOptionsType } from "embla-carousel";
import useEmblaCarousel from "embla-carousel-react";
import ClassNames from "embla-carousel-class-names";
import {
  NextButton,
  PrevButton,
  usePrevNextButtons,
} from "./CarouselArrowButtons/CarouselArrowButtons";
import {
  DotButton,
  useDotButton,
} from "./CarouselDotButtons/CarouselDotButtons";
import classNames from "classnames";

type PropType = {
  children: React.ReactNode;
  options?: EmblaOptionsType;
};

const Carousel: FC<PropType> = ({ options, children }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(options, [ClassNames()]);

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <div className="max-w-48rem mx-auto">
      {(!prevBtnDisabled || !nextBtnDisabled) && (
        <div className="max-w-full mb-10">
          <div className="max-w-full flex justify-end">
          <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <div className="max-w-[36px] w-full md:w-full"></div>
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
          </div>
        </div>
      )}

      <div className="overflow-hidden" ref={emblaRef}>
        <div className="backface-hidden flex touch-pan-y">{children}</div>
      </div>
    </div>
  );
};

export default Carousel;
